import axios from 'axios'
import {URL} from '../../util/ambienteActions';
import {LISTAR_FILTROS_CUPOM} from '../types';

export default function listarFiltrosCupom() {
    const url = `${URL}/cupom/filtros`;

    return dispatch => axios.get(url).then(
        response => dispatch({
            type: LISTAR_FILTROS_CUPOM,
            payload: response

        })
    );
}
